import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type StandardReportsEvents = 'TABLE_NAME_CELL_CLICK';

export const standardReports: Record<StandardReportsEvents, MixpanelEvent> = {
  TABLE_NAME_CELL_CLICK: {
    eventDescription: 'Standard Reports Table Name Cell Click',
    eventKey: 'standardReports-table-name-cell-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.DATA_TABLE_CELL
  }
} as const;
